import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {
  checkBidInfo,
  checkSecurityInfo,
  popUpTypes,
  unCheckBidInfo,
  unCheckSecurityInfo,
  openPopUp,
  closePopUp,
  setPopUp, steps,
  setStep,
  saveToHistory
} from '../IdfNewPlanSignupSlice';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import BottomButtons from 'app/Components/Block/IdfSaleBlock/Constans/BottomButtons';
import {
  createReportIdfNewPlanSignupApprovalInformationSecurity,
  createReportIdfNewPlanSignupApprovalTenderSummary,
  createReportIdfNewPlanSignupContinueToStep3,
  createReportIdfNewPlanSignupPersonalInformationPageDisplayed,
  createReportIdfNewPlanSignupSignupFormClick
} from 'app/utilities/reports/createReport';

const AgreementsStep = (props) => {

  useEffect(() => {
    props.saveToHistory('agreements');
    createReportIdfNewPlanSignupPersonalInformationPageDisplayed(
      props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
      props.userData?.loginData.userDetails.contactNumber,
      props.userData?.loginData.userDetails.IDNumber,
      props.idfNewPlanSignup.nextBpKey,
      props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value
    )
  }, []);

  useEffect(() => {
    if (props.idfNewPlanSignup.checkedSecurityInfo) {
      createReportIdfNewPlanSignupApprovalInformationSecurity(
        props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
        props.userData?.loginData.userDetails.contactNumber,
        props.userData?.loginData.userDetails.IDNumber,
        props.idfNewPlanSignup.nextBpKey,
        props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value
      )
    }
  }, [props.idfNewPlanSignup.checkedSecurityInfo]);

  useEffect(() => {
    if (props.idfNewPlanSignup.checkedBidInfo) {
      createReportIdfNewPlanSignupApprovalTenderSummary(
        props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
        props.userData?.loginData.userDetails.contactNumber,
        props.userData?.loginData.userDetails.IDNumber,
        props.idfNewPlanSignup.nextBpKey,
        props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value
      )
    }
  }, [props.idfNewPlanSignup.checkedBidInfo]);

  const handleClickOpenPopUp = (popUp) => {
    createReportIdfNewPlanSignupSignupFormClick(
      props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
      props.userData?.loginData.userDetails.contactNumber,
      props.userData?.loginData.userDetails.IDNumber,
      props.idfNewPlanSignup.nextBpKey,
      props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value
    )
        props.setPopUp(popUp);
      props.openPopUp();
    }

  const isContinueDisabled = () => {
    return !props.idfNewPlanSignup.checkedSecurityInfo || !props.idfNewPlanSignup.checkedBidInfo || !props.idfNewPlanSignup.signupForm.signed;
    }

  const handleContinue = () => {
    createReportIdfNewPlanSignupContinueToStep3(
      props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
      props.userData?.loginData.userDetails.contactNumber,
      props.userData?.loginData.userDetails.IDNumber,
      props.idfNewPlanSignup.nextBpKey,
      props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value
    )
    props.setStep(steps.CONFIRMATION);
  };

  return (
        <div className={'agreements-content'}>
               <div className={'top-content'}>
                <div className={'text-container'}>
                    <span className="main-title">כמעט סיימנו</span>
                    <span className="secondary-title">אשרו את המסמכים הבאים</span>
                </div>
                   <div className={'agreements'}>
                  <div className={'agreement'}>
                      <Image className={'icon'} src={require('../images/contract.svg')}  alt={'contract'} />
                      <button onClick={()=> handleClickOpenPopUp(popUpTypes.SIGNUP_FORM)} className={'link underline'}>לחצו כאן לחתימה על טופס הצטרפות</button>
                  </div>
                    <div className={'agreement'}>
                        <div>
                            <CheckBox
                                id='securityInfo'
                                onCheck={props.checkSecurityInfo}
                                onUncheck={props.unCheckSecurityInfo}
                                checked={props.checkedSecurityInfo}
                            ></CheckBox>
                        </div>
                      <span className={'agreement-text'}>קראתי ואני מאשר <a
                        href={props.idfNewPlanSignup?.securityFormUrl} target="_blank" className={'underline black'}>טופס ביטחון מידע</a></span>
                    </div>
                    <div className={'agreement'}>
                        <div>
                            <CheckBox
                                id='bidInfo'
                                onCheck={props.checkBidInfo}
                                onUncheck={props.unCheckBidInfo}
                                checked={props.checkedBidInfo}
                            >
                            </CheckBox>
                        </div>
                      <span className={'agreement-text'}>קראתי ואני מאשר <a
                        href={props.idfNewPlanSignup?.auctionFormUrl}
                        target="_blank"
                        className={'underline black'}>טופס עיקרי מכרז הסלולר</a></span>
                    </div>
                </div>
               </div>
                <div className={'bottom-container'}>
                  <BottomButtons onClickNavigation={handleContinue} canContinue={!isContinueDisabled()} />
                </div>

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        idfNewPlanSignup: state.idfNewPlanSignup,
        userData: state.authentication

    };
};

const mapDispatchToProps = {
    checkSecurityInfo,
    checkBidInfo,
    unCheckBidInfo,
    unCheckSecurityInfo,
    openPopUp,
    closePopUp,
  setPopUp,
  setStep,
  saveToHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(AgreementsStep);
